import { render, staticRenderFns } from "./PropertyRoleItem.vue?vue&type=template&id=e7dc7142&"
import script from "./PropertyRoleItem.vue?vue&type=script&lang=ts&"
export * from "./PropertyRoleItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports